module.exports = __webpack_public_path__ + "static/media/2.f0f2990d.jpg";